<template>
    <div>
        <div class="create_page_header" :style="{ width: fixWidth }">
            <el-button type="text" icon="el-icon-back" :style="{ fontSize: '14px' }" @click="handleClick" v-matomo="{behaviorCategory: 'OPPO(列表)',  name: '任务详情(返回)' }">返回</el-button>
            <span class="text pl10 pr10 font14px">|</span>
            <span class="text pr10 font14px text-bold">批量创建详情</span>
            <span class="ml20 text-color-gray text-bold"> 任务ID： {{ id }}</span>
        </div>
        <div class="create_page_body">
            <div class="form-box mb10">
                <el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline" size="mini">
                    <el-form-item prop="account_id">
                        <CustomInput label='目标账户'>
                            <SelectAll v-model="formInline.account_id" :placeholder="'支持账户名称关键字或用户名搜索'" :multiple=false
                                style="width:230px;" :remote=true
                                :remote-query="(query) => fetchApi({ task_id: id, search_type: 'account', query: query })" />
                        </CustomInput>
                    </el-form-item>
                    <el-form-item prop="app_id">
                        <CustomInput label='产品'>
                            <SelectAll v-model="formInline.app_id" :placeholder="'产品名称、ID、包名关键字搜索'" style="width:230px;"
                                :remote=true
                                :remote-query="(query) => fetchApi({ task_id: id, search_type: 'app', query: query })" />
                        </CustomInput>
                    </el-form-item>
                    <el-form-item prop="plan_id">
                        <CustomInput label='计划'><el-input v-model="formInline.plan_id" placeholder="支持计划名称关键字或ID搜索"
                                style="width:230px;" clearable /></CustomInput>
                    </el-form-item>
                    <el-form-item prop="adgroup_id">
                        <CustomInput label='广告组'>
                            <el-input v-model="formInline.adgroup_id" placeholder="支持广告组名称关键字或ID搜索" style="width:230px;"
                                clearable />
                        </CustomInput>
                    </el-form-item>
                    <el-form-item prop="ad_id">
                        <CustomInput label='广告'>
                            <el-input v-model="formInline.ad_id" placeholder="支持广告名称关键字或者ID搜索" style="width:230px;"
                                clearable />
                        </CustomInput>
                    </el-form-item>
                    <el-form-item prop="status">
                        <CustomInput label='状态'>
                            <el-select v-model="formInline.status" placeholder="全部" multiple style="width:120px;"
                                clearable>
                                <el-option label="创建中" value="1"></el-option>
                                <el-option label="创建成功" value="2"></el-option>
                                <el-option label="创建计划失败" value="3"></el-option>
                                <el-option label="创建广告组失败" value="4"></el-option>
                                <el-option label="创建广告失败" value="5"></el-option>
                            </el-select>
                        </CustomInput>
                    </el-form-item>
                </el-form>
                <div class="opts">
                    <el-button type="primary" @click="onSubmit" v-matomo="{behaviorCategory: 'OPPO(列表)',  name: '任务详情(查询)' }">筛选</el-button>
                    <el-button @click="resetForm('formInline')" v-matomo="{behaviorCategory: 'OPPO(列表)',  name: '任务详情(重置筛选)' }">重置筛选</el-button>
                </div>
            </div>

            <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5 order_table_no_border">
                <el-table :data="tableData" style="width: 100%;" stripe
                    :header-cell-style="{ background: '#e8eaec', color: '#333' }" size="mini"
                    :expand-row-keys="expandrowkeys" row-key="id" ref="toggleRowEx" class="create_vivo_list"
                    v-loading="loading" tooltip-effect="dark">
                    <el-table-column type="expand" width="1">
                        <template slot-scope="scope">
                            <div class="full-w" v-loading="scope.row.expendLoading">
                                <ExpandItem :params="scope.row.params" />
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="120">
                        <template slot-scope="scope">
                            <template v-if="scope.$index == 0">
                                <span>汇总(成功/失败)</span>
                            </template>
                            <template v-else>
                                <p v-if="scope.row.status == 1" class="text-color-info">{{ scope.row.status_text }}<i
                                        class="el-icon-loading"></i></p>
                                <p v-else-if="scope.row.status == 2" class="text-color-success">{{ scope.row.status_text
                                    }}
                                </p>
                                <p v-else class="text-color-error">{{ scope.row.status_text }}<el-tooltip class="item"
                                        effect="dark" :content="scope.row.err_msg" placement="top-start"><i
                                            class="el-icon-warning-outline"></i></el-tooltip></p>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="目标账户" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div v-if="scope.$index == 0">{{ scope.row.success_account_num }}/{{
            scope.row.err_account_num }}
                            </div>
                            <div v-else>
                                <p class="ellipsis">{{ scope.row.account_name }}</p>
                                <br>
                                <p class="ellipsis">ID:{{ scope.row.account_id }}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="投放产品" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div v-if="scope.$index == 0">{{ scope.row.success_app_num }}/{{ scope.row.err_app_num }}
                            </div>
                            <div v-else>
                                <p class="ellipsis">{{ scope.row.app_name }}({{ scope.row.app_id }})</p>
                                <br>
                                <p class="ellipsis">{{ scope.row.app_package_name }}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="计划名称" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div v-if="scope.$index == 0">{{ scope.row.success_plan_num }}/{{ scope.row.err_plan_num }}
                            </div>
                            <div v-else>
                                <p class="ellipsis">{{ scope.row.plan_name }}</p>
                                <br />
                                <p class="ellipsis" v-if="scope.row.plan_id">ID:{{ scope.row.plan_id }}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="广告组名称" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div v-if="scope.$index == 0">{{ scope.row.success_adgroup_num }}/{{
            scope.row.err_adgroup_num }}
                            </div>
                            <div v-else>
                                <p class="ellipsis">{{ scope.row.adgroup_name }}</p>
                                <br />
                                <p class="ellipsis" v-if="scope.row.adgroup_id">ID:{{ scope.row.adgroup_id }}</p>
                            </div>
                        </template>
                    </el-table-column>

            <el-table-column label="广告名称" min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div v-if="scope.$index==0">{{scope.row.success_ad_num}}/{{scope.row.err_ad_num}}</div>
                    <div v-else>
                        <p class="ellipsis">{{ scope.row.ad_name }}</p>
                        <br/>
                        <p class="ellipsis" v-if="scope.row.ad_id">ID:{{scope.row.ad_id}}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="90" fixed="right">
                <template slot-scope="scope">
                        <el-button
                            v-if="scope.$index!=0"
                        size="mini"
                        type="text"
                        @click="toggleRow(scope.$index, scope.row)"
                        v-matomo="{behaviorCategory: 'OPPO(列表)',  name: '任务详情(创意详情)' }"
                        >创意详情<i class="el-icon-arrow-down" v-if="!scope.row.expend"></i><i class="el-icon-arrow-up" v-else></i></el-button>
                </template>
            </el-table-column>
        </el-table>

                <div style="text-align: right;padding-top: 20px;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import ExpandItem from '../components/expandItem';
import API from '@/api/marketManage/oppoBatch.js';
import SelectAll from '@/components/SelectAll'
import CustomInput from '@/components/CustomInput'
import { mapGetters } from "vuex";
export default {
    name: "infopage",
    components: {
        ExpandItem,
        SelectAll,
        CustomInput
    },
    props: {
        id: ''
    },
    data() {
        return {
            fetchApi: API.getDetailSearchList,
            fixWidth: '1000px',
            formInline: {
                account_id: '',      //任务ID
                plan_id: '',      //计划
                adgroup_id: '',   //广告组ID
                ad_id: '',        //广告ID
                status: '',        //状态
                app_id: []  //投放产品
            },
            // account: [],            //select搜索
            // plan: [],            //select搜索
            // group: [],            //select搜索
            app: [],            //select搜索
            gather: {               //数据汇总
                err_account_num: "",
                err_ad_num: "",
                err_adgroup_num: "",
                err_app_num: "",
                err_idea_num: "",
                success_ad_num: "",
                err_plan_num: "",
                success_account_num: "",
                success_app_num: "",
                success_idea_num: "",
                success_plan_num: ""
            },
            params: {},  //创意详情
            loading: true,  // 表格loading
            expanditemloading: true,  //创意详情loading
            currentPage: 1,
            pageSize: 10,
            total: 10,
            monitor: null, //定时器
            equal: 1, //缓存请求赋值
            status_err: [],
            tableData: [],
            dialogVisible: false,
            expandrowkeys: [],  //展开行
            lock: false,
            timer: 5,
            updateIds: []
        }
    },
    mounted() {
        this.getFixWidth();
        window.addEventListener("resize", this.getFixWidth);
        this.init()
    },
    computed: {
        ...mapGetters(['sidebar']),
    },
    watch: {
        sidebar: {
            handler() {
                setTimeout(this.getFixWidth, 300)
            },
            deep: true,
        }
    },
    methods: {
        getFixWidth() {
            let $createBody = document.querySelector('.create_page_body');
            this.fixWidth = `${$createBody.clientWidth + 20}px`;
        },
        toConfigPage() {
            this.$emit("changePage", "config")
        },
        remoteMethod(query, type) {
            if (!query) return;
            API.getDetailSearchList({
                task_id: this.id,
                // plan_id:this.formInline.plat_id,
                search_type: type,
                query: query
            }).then(res => {
                let result = res.data
                this[type] = result
            })
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.handleKill()
            this.lock = true
            this.init()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            this.handleKill()
            this.lock = true
            this.init()
        },
        onSubmit() {
            this.handleKill()
            this.lock = true
            this.currentPage = 1
            this.init()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.lock = true
            this.currentPage = 1
            this.$nextTick(() => {
                this.init()
            })
        },
        toggleRow(index, row) {
            this.$refs.toggleRowEx.toggleRowExpansion(row);
            row.params = [];
            row.expendLoading = true

            row.expend = !row.expend
            // // if判断处理当前行自身收起展开
            // if(this.expandrowkeys.length == 1 && this.expandrowkeys[0] == index) {
            //     this.tableData[index].expend = !this.tableData[index].expend
            //     this.$refs.toggleRowEx.toggleRowExpansion(row)
            //     this.expanditemloading = false
            //     return
            // }
            API.getDetailIdeaList({ detail_id: row.detail_id }).then(res => {
                // this.params = res.data||{};
                // this.expanditemloading = false
                row.params = res.data
                row.expendLoading = false
            }).catch((err) => {
                this.$message.error(err.info)
            })
        },
        handleClick() {
            this.handleKill()
            this.delayedClear()
            this.$emit('goback')
        },
        init() {
            this.handleKill()
            let obj = { ...this.formInline, pn: this.currentPage, rn: this.pageSize, task_id: this.id }
            this.loading = true
            this.updateIds = []

            this.polling()
        },
        polling() {
            let params = { ...this.formInline, pn: this.currentPage, rn: this.pageSize, task_id: this.id }
            return API.getDetailTotalData(params).then(totalList => {
                this.gather = totalList.data
                API.getDetailDataList(params).then(res => {
                    let result = res.data
                    this.loading = false

                    let createarr = []
                    result.list.forEach(element => {
                        if (element.status == 1) {
                            createarr.push(element.id)
                        }
                    });
                    this.updateIds = createarr

                    this.tableData = [this.gather].concat(result.list.map(((item, index) => {
                        item.id = index
                        item.expendLoading = false;
                        item.params = [];
                        return { ...item }
                    })));
                    this.currentPage = result.pageNum
                    this.pageSize = result.pageSize
                    this.total = result.totalCnt

                    if (createarr.length !== 0) {
                        // let obj = {...this.formInline, pn: this.currentPage, rn: this.pageSize, task_id:this.id}
                        // this.monitor = setTimeout(()=>{this.polling(obj, 'updateStatus')}, 5000)
                        // this.updateListStatus()
                    } else {
                        this.handleKill()
                    }

                })
            })
        },
        updateListStatus() {
            if (this.lock || !this.updateIds.length) {
                return
            }
            this.timer = 5
            this.lock = true;
            let time = null;
            time = setInterval(() => {
                if (this.timer <= 0) {
                    clearInterval(time);
                    // this._updateListStatus()
                    this.polling().finally(() => {
                        this.lock = false
                        if (this.updateIds) {
                            this.updateListStatus()
                        }
                    })
                } else {
                    --this.timer
                }
            }, 1000)
        },
        handleKill() {
            for (let i = 1; i < 10; i++) {
                clearTimeout(this.monitor)
                this.monitor = null
                this.equal = 1
            }

        },
        delayedClear() {
            setTimeout(() => {
                for (let i = 1; i < 10; i++) {
                    clearTimeout(this.monitor)
                    this.monitor = null
                    this.equal = 1
                }
            }, 5000)
        }
    },
    beforeDestroy() {
        this.handleKill()
        this.delayedClear()
        window.removeEventListener("resize", this.getFixWidth);
    },
    destroyed() {
        this.handleKill()
        this.delayedClear()
    }
}
</script>

<style>
.create_vivo_list .el-table__expand-icon .el-icon-arrow-right {
    opacity: 0;
}
</style>
<style lang="scss" scoped>
@import "~@/styles/material_sd.scss";
.opts {
    border-top: 1px solid #DCDFE6;
    padding-top: 10px;
}
.form-box {
    background: #ffffff;
    padding: 20px 10px;
    border-radius: 4px;
}
.ellipsis {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.create_vivo_list tbody .cell div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.create_page_header {
    background-color: #fff;
    padding: 2px 8px;
    display: flex;
    align-items: center;
    position: fixed;
    top: 52px;
    z-index: 30;
    box-shadow: 0 1px 2px #d9d9d9;
    transform: translateX(-10px);
    .text {
        display: inline-block;
        line-height: 32px;
    }
}

.create_page_body {
    min-height: calc(100vh - 135px);
    padding-bottom: 50px;
}

.min-height-150 {
    min-height: 150px;
}
</style>
